const fastSellProductInboundFormInitialValues = (fastSellProduct) => ({
  inbound_courier     : fastSellProduct?.inbound_courier || '',
  inbound_shipping_no : fastSellProduct?.inbound_shipping_no || ''
})


export default fastSellProductInboundFormInitialValues
